export default __webpack_public_path__ + "static/media/archi_slider_7.63e29540.webp";